// extracted by mini-css-extract-plugin
module.exports = {"SyncfusionEditorTitle":"RemarkEditor_SyncfusionEditorTitle__AYIVS"};